module.exports = __webpack_public_path__ + "img/shopline.3bde2b15.png";